import { COLORS } from '@constants';
import { Button } from '@ui';
import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledBanner = styled(Flex)`
    background-color: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
    padding: 24px;
    gap: 24px;
    align-items: center;
    width: 100%;
`;

export const StyledIconWrapper = styled.div`
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledBadge = styled.div`
    background-color: ${COLORS.$robinBlue};
    border: 1px solid ${COLORS.$robinBlue};
    border-radius: 12px;
    padding: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const StyledBadgeNoColor = styled.div`
    background-color: transparent;
    border: none;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const StyledBadgeError = styled.div`
    background-color: ${COLORS.$error};
    border: 1px solid ${COLORS.$error};
    border-radius: 12px;
    padding: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const StyledButton = styled(Button)`
    border: 2px solid ${COLORS.$gray20Black};
    border-radius: 8px;
    height: 56px;
    width: 187px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-color: ${COLORS.$white};

    &:hover {
        border-color: ${COLORS.$gray40Black};
    }
`;
